// Ported from dev-scrips-pm-react services/billing/use-service-fees.ts (PROD-1190 calendar port)
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { post } from '@/services/api-client';

/**
 * POST /api/Billing/Services/Fees?pageNumber=1&pageSize=50&q=<query>
 *
 * Mirrors Flutter `fetchServicesFees()` →
 * `billing_module/data/datasources/billing_data_source_impl.dart:418-446`.
 * Body `type` switches between provider-specific ("provider") and the
 * full catalog ("all") — matches the Provider Fees / All tabs in the
 * Add Procedure Codes popup.
 */

export interface ServiceFee {
  id?: string;
  procedureCode?: { code?: string; displayName?: string };
  shortDescription?: string;
  fees?: { id?: string; fee?: number; location?: { id?: string; name?: string } }[];
}

export interface ServiceFeesResponse {
  pageNumber?: number;
  pageSize?: number;
  totalNumberOfPages?: number;
  totalNumberOfRecords?: number;
  results?: ServiceFee[];
}

interface UseServiceFeesParams {
  providerId?: string | null;
  locationId?: string | null;
  patientId?: string | null;
  type: 'provider' | 'all';
  query?: string;
  pageNumber?: number;
  pageSize?: number;
}

export function useServiceFees(params: UseServiceFeesParams | null) {
  return useQuery({
    queryKey: ['service-fees', params],
    enabled: !!params?.providerId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => {
      if (!params) throw new Error('useServiceFees called without params');
      const qs = new URLSearchParams();
      qs.set('pageNumber', String(params.pageNumber ?? 1));
      qs.set('pageSize', String(params.pageSize ?? 50));
      if (params.query) qs.set('q', params.query);
      const body = {
        providerId: params.providerId ?? null,
        locationId: params.locationId ?? null,
        patientId: params.patientId ?? null,
        type: params.type,
      };
      return post<ServiceFeesResponse>(
        `/api/Billing/Services/Fees?${qs.toString()}`,
        body,
        { signal },
      );
    },
  });
}
